import Box from 'lib/ui/Box'
import Grid from 'lib/ui/Grid'
import Text from 'lib/ui/Text'

import DefaultLayout from '../DefaultLayout'
import { useCompanyAndInvoiceContext } from '@/hooks/providers/CompanyAndInvoiceProvider'
import Button from '@/ui/Button'

const ErrorLayout = () => {
  const { company } = useCompanyAndInvoiceContext()

  return (
    <div data-testid='error-page'>
      <DefaultLayout
        headline='Sorry'
        title='Alternative - Page does not exists'
        center
        alignment='center'
      >
        <Box alignment='center'>
          <Text color='grey25' size='md' margin={[0, 0, 2]}>
            {company === null
              ? 'This company is not enabled for Alternative Payments'
              : 'You do not have access to this resource or this page does not exist.'}
          </Text>
          <Grid breakpoint='sm' gap={3.2} columns='1fr 1fr'>
            <Button href='/dashboard' variant='primary'>
              Dashboard
            </Button>
            <Button href='https://alternativepayments.io' variant='primary'>
              About Alternative
            </Button>
          </Grid>
        </Box>
      </DefaultLayout>
    </div>
  )
}

export default ErrorLayout
